import { HTTP } from "../../service/helper";

const state = () => ({
    promoPostLists: "",
});

const getters = {
    getPromoPostLists(state){
        return state.promoPostLists;
    },
};

const actions = {
    getPromoPostLists({ commit }){
        return new Promise((resolve,reject) => {
            HTTP.get("/v1/promo-post-list")
            .then((response) => {
                commit("setPromoPostLists", response.data.data);
                resolve(response);
            })
            .catch((error) => {
                reject(error.response.data);
            })
        });
    },

    promoPostDetail(_,id){
        return new Promise((resolve, reject) => {
            HTTP.get("/v1/promo-post-detail/"+id+"")
               .then((response) => {
                  resolve(response);
               })
               .catch((error) => {
                  reject(error.response.data);
               });
         });
    }

};

const mutations = {
    setPromoPostLists(state,payload){
        state.promoPostLists = payload
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}